import React from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';

const IncorrectShop = ({ authorization: { shopList } }) => (
  <div className="app-wrapper page-error-container animated slideInUpTiny animation-duration-3">
    <div className="page-error-content">
      <div className="error-code mb-4 animated zoomInDown"><IntlMessages id="ui.kea.placeholders.incorrectShop.oops" /></div>
      <h2 className="text-center fw-regular title bounceIn animation-delay-10 animated">
        <IntlMessages id="ui.kea.placeholders.incorrectShop.incorrectShop" />
        <br />
        {
          shopList.length
            ? <IntlMessages id="ui.kea.placeholders.incorrectShop.chooseShop" />
            : <IntlMessages id="ui.kea.placeholders.incorrectShop.reloadOrContactSupport" />
        }
        {
          shopList.map((shop) => (
            <Link
              to={`/app/${shop.shopId}/home`}
              key={shop.shopId}
            >
              <Button
                style={{ margin: 5 }}
                variant="contained"
                color="primary"
                className="jr-btn"
              >
                {shop.shopId}
              </Button>
            </Link>
          ))
        }
      </h2>

    </div>
  </div>
);

export default IncorrectShop;
